import { useState, useEffect } from 'react';
import './SectionRankings.css';

const SectionRankings = ({ rawData }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger progress bar filling animation after mounting
    const timer = setTimeout(() => setAnimate(true), 150);
    return () => clearTimeout(timer);
  }, [rawData]);

  const categories = [
    { name: 'AI Awareness & Structured Data', score: Math.round(rawData?.raw_score ?? 0) },
    { name: 'Content Quality & Freshness', score: Math.round(rawData?.content_raw_score ?? 0) },
    { name: 'Performance Optimization', score: Math.round(rawData?.optimization_raw_score ?? 0) },
    { name: 'Internal Linking / Entity Clarity', score: Math.round(rawData?.link_structure_raw_score ?? 0) },
    { name: 'Technical SEO', score: Math.round(rawData?.technical_seo_raw_score ?? 0) },
    { name: 'User Engagement / Conversion', score: Math.round(rawData?.user_engagement_raw_score ?? 0) },
  ];

  // Sort categories in ascending order of their scores (lowest first) to get the worst performing
  const worstCategories = [...categories]
    .sort((a, b) => a.score - b.score)
    .slice(0, 2);

  return (
    <div className="section-rankings-container">
      <h5 className="rankings-title">Key Improvement Areas</h5>
      <div className="rankings-list">
        {worstCategories.map((category, index) => (

          <div key={index} className="ranking-row">
            <div className="ranking-label">
              {category.name}
            </div>
            <div className="ranking-bar-wrapper">
              <div className="ranking-bar-track">
                <div 
                  className="ranking-bar-fill"
                  style={{ 
                    width: animate ? `${category.score}%` : '0%' 
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionRankings;
